import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Zap, Search, Trash2 } from 'lucide-react';
import { useAppStore } from '../store';

export default function Jobs() {
  const jobs = useAppStore(s => s.jobs);
  const deleteJob = useAppStore(s => s.deleteJob);
  const [search, setSearch] = useState('');

  const filtered = jobs.filter(j =>
    j.id.toLowerCase().includes(search.toLowerCase()) ||
    j.customer.toLowerCase().includes(search.toLowerCase()) ||
    (j.part_no || '').toLowerCase().includes(search.toLowerCase()) ||
    (j.description || '').toLowerCase().includes(search.toLowerCase())
  );

  const statusMap: Record<string, { cls: string; label: string }> = {
    DRAFT: { cls: 'badge-gray', label: 'Draft' },
    PARSING: { cls: 'badge-yellow', label: 'Parsing' },
    REVIEW: { cls: 'badge-blue', label: 'Review' },
    PLANNING: { cls: 'badge-orange', label: 'Planning' },
    APPROVED: { cls: 'badge-green', label: 'Approved' },
    COMPLETE: { cls: 'badge-green', label: 'Complete' },
  };

  return (
    <div className="fade-in">
      <div className="section-header">
        <h1>Jobs</h1>
        <Link to="/new-job" className="btn btn-primary">
          <Zap size={13} /> New Job
        </Link>
      </div>

      <div style={{ marginBottom: 20, position: 'relative' }}>
        <Search size={13} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--forge-text3)' }} />
        <input className="input" style={{ paddingLeft: 32 }} placeholder="Search jobs, customers, part numbers…"
          value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      {filtered.length === 0 ? (
        <div className="empty-state">
          <p>{search ? 'No jobs match your search.' : 'No jobs yet.'}</p>
          {!search && <Link to="/new-job" className="btn btn-primary btn-sm" style={{ marginTop: 12 }}><Zap size={12} /> Create first job</Link>}
        </div>
      ) : (
        <div className="card" style={{ padding: 0 }}>
          <table>
            <thead>
              <tr>
                <th>Job ID</th>
                <th>Part No.</th>
                <th>Customer</th>
                <th>Description</th>
                <th>Machine</th>
                <th>Status</th>
                <th>Created</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(job => {
                const { cls, label } = statusMap[job.status] ?? { cls: 'badge-gray', label: job.status };
                return (
                  <tr key={job.id}>
                    <td><Link to={`/jobs/${job.id}`} style={{ color: 'var(--forge-accent)', textDecoration: 'none', fontFamily: 'var(--font-mono)', fontSize: 11 }}>{job.id}</Link></td>
                    <td style={{ fontFamily: 'var(--font-mono)', fontSize: 11 }}>{job.part_no || '—'}</td>
                    <td>{job.customer || '—'}</td>
                    <td style={{ color: 'var(--forge-text2)', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{job.description || '—'}</td>
                    <td style={{ fontSize: 11 }}>{job.selected_machine ? job.selected_machine.replace(/_/g,' ') : '—'}</td>
                    <td><span className={`badge ${cls}`}>{label}</span></td>
                    <td style={{ color: 'var(--forge-text3)', fontSize: 11 }}>{new Date(job.created_at).toLocaleDateString()}</td>
                    <td>
                      <button className="btn btn-ghost btn-sm" onClick={e => { e.preventDefault(); if (window.confirm('Delete this job?')) deleteJob(job.id); }}>
                        <Trash2 size={11} />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
